export function usePrintReceipt() {
  const handlePrintGameReceipt = (time?: number) => {
    setTimeout(() => {
      window.print()
    }, time || 1000)
  }

  return { handlePrintGameReceipt }
}
